import { ProviderTypes, TypeaheadProviderTypes } from '../../Constants';

export function internalConvertProviderTypeToAdobeType(internalProviderType) {
  if (
    internalProviderType?.toLowerCase() ===
    ProviderTypes?.PRACTITIONER.toLowerCase()
  )
    return 'provider';
  if (
    internalProviderType?.toLowerCase() ===
      ProviderTypes?.ORGANIZATION.toLowerCase() ||
    internalProviderType?.toLowerCase() ===
      ProviderTypes?.FACILITY.toLowerCase() ||
    internalProviderType?.toLowerCase() ===
      TypeaheadProviderTypes?.MEDICAL_HEALTH_SUPPLIES.toLowerCase()
  )
    return 'facilities';
  if (
    internalProviderType?.toLowerCase() ===
      ProviderTypes.MEDICAL_GROUP.toLowerCase() ||
    internalProviderType?.toLowerCase() ===
      ProviderTypes?.MEDICALGROUP.toLowerCase() ||
    internalProviderType?.toLowerCase() === ProviderTypes?.GROUP.toLowerCase()
  )
    return 'medical group';

  return undefined;
}

export function convertProviderTypeToAdobeType(internalProviderType) {
  const name = internalConvertProviderTypeToAdobeType(internalProviderType);
  return name || internalProviderType?.toLowerCase();
}
